/**
 * Calculates display-related configurations based on layout rules
 */
export class DisplayConfiguration {
  /**
   * Gets maximum color swatch count for desktop view
   */
  static getMaxColorSwatchCountDesktop(tilesCount: number, sideBarEnabled: boolean): number {
    if (tilesCount > 4 || sideBarEnabled) return 6
    return 8
  }

  /**
   * Gets number of colors to display based on screen size
   */
  static getNumberOfColorsToDisplay(screenClass: string, colorSwatchCount: number): number {
    return screenClass === 'xs' ? 4 : colorSwatchCount
  }

  /**
   * Gets number of product tiles per row based on section type and configuration
   */
  static getNumberOfTilesPerRow(
    sidebarEnabled: boolean,
    sectionType: string,
    tilesCount: number
  ): number {
    switch (sectionType) {
      case 'product grid horizontal':
        return 3
      case 'product grid horizontal XL':
        return 2
      default:
        return this.getDefaultTilesPerRow(sidebarEnabled, tilesCount)
    }
  }

  private static getDefaultTilesPerRow(sidebarEnabled: boolean, tilesCount: number): number {
    if (tilesCount <= 4) return 4
    return sidebarEnabled ? 4 : 6
  }
}
